<template>
  <div>
    <Pane />

    <a-card class="container">
      <!-- 搜索表单 -->
      <a-form-model
        :colon="false"
        :model="form"
        layout="inline"
        @keyup.enter.native="query"
      >
        <!-- 收起：前3个字段+按钮 -->
        <a-form-model-item>
          <a-input v-model="form.projectName" placeholder="项目名称" allow-clear style="width: 160px" />
        </a-form-model-item>
        <a-form-model-item>
          <a-input v-model="form.filingNum" placeholder="备案编号" allow-clear style="width: 160px" />
        </a-form-model-item>
        <a-form-model-item>
          <a-input v-model="form.ownerCompanyName" placeholder="业主单位" allow-clear style="width: 160px" />
        </a-form-model-item>
        <!-- 展开：其余字段+按钮 -->

        <a-form-model-item>
          <a-input v-model="form.contactName" placeholder="联系人" allow-clear style="width: 160px" />
        </a-form-model-item>
        <a-form-model-item>
          <a-select v-model="form.status" placeholder="项目状态" allow-clear style="width: 160px">
            <a-select-option v-for="item in approveStatusDict" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-select v-model="form.areaId" placeholder="所属区域" allow-clear style="width: 160px">
            <a-select-option v-for="item in areaList" :key="item.id" :value="item.id">{{ item.areaName }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-cascader
            v-model="form.location"
            :options="cityList"
            placeholder="项目所在地"
            allow-clear
            :fieldNames="{ label: 'name', value: 'name', children: 'children' }"
            @change="locationChange"
            style="width: 200px"
          />
        </a-form-model-item>

        <a-form-model-item v-if="!searchExpanded">
          <a-space>
            <a-button type="primary" icon="search" @click="query">搜索</a-button>
            <a-button icon="redo" @click="reset">清空</a-button>
            <a @click="searchExpanded = true" style="font-size: 13px">
              展开 <a-icon type="down" style="font-size: 12px" />
            </a>
          </a-space>
        </a-form-model-item>

        <template v-if="searchExpanded">
          <a-form-model-item>
            <a-select v-model="form.projectProperty" placeholder="项目属性（专业/类别）" allow-clear mode="multiple" :max-tag-count="1" style="width: 200px">
              <a-select-opt-group label="专业">
                <a-select-option v-for="item in specialtyDict" :key="'s_' + item.value" :value="'s_' + item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select-opt-group>
              <a-select-opt-group label="类别">
                <a-select-option v-for="item in categoryDict" :key="'c_' + item.value" :value="'c_' + item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select-opt-group>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-select v-model="form.projectClassify" placeholder="项目分类" allow-clear style="width: 160px">
              <a-select-option v-for="item in classifyDict" :key="item.value" :value="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-select v-model="form.biddingType" placeholder="招投标方式" allow-clear style="width: 160px">
              <a-select-option v-for="item in biddingTypeDict" :key="item.value" :value="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-select
              v-model="form.registerDeptId"
              placeholder="登记部门"
              allow-clear
              show-search
              :filter-option="$selectFilterOption"
              style="width: 160px"
            >
              <a-select-option v-for="item in productionOrgList" :key="item.id" :value="item.id">{{ item.uniqueName }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <EmployeeSelector
              @change="(arr) => { form.registerUserId = arr.length ? arr[0].userId : undefined; registerUserName = arr.length ? arr[0].name : '' }"
              :value="form.registerUserId ? [{ userId: form.registerUserId, name: registerUserName }] : []"
            >
              <a-button style="width: 160px; text-align: left">
                <span v-if="registerUserName">{{ registerUserName }}</span>
                <span v-else style="color: #bfbfbf">登记人</span>
              </a-button>
            </EmployeeSelector>
          </a-form-model-item>
          <a-form-model-item>
            <a-select
              v-model="form.productionDeptId"
              placeholder="主办生产部门"
              allow-clear
              show-search
              :filter-option="$selectFilterOption"
              style="width: 160px"
            >
              <a-select-option v-for="item in productionOrgList" :key="item.id" :value="item.id">{{ item.uniqueName }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <EmployeeSelector
              @change="(arr) => { form.chargeUserId = arr.length ? arr[0].userId : undefined; chargeUserName = arr.length ? arr[0].name : '' }"
              :value="form.chargeUserId ? [{ userId: form.chargeUserId, name: chargeUserName }] : []"
            >
              <a-button style="width: 160px; text-align: left">
                <span v-if="chargeUserName">{{ chargeUserName }}</span>
                <span v-else style="color: #bfbfbf">负责人</span>
              </a-button>
            </EmployeeSelector>
          </a-form-model-item>
          <a-form-model-item>
            <a-select v-model="form.infoSourceType" placeholder="信息来源" allow-clear style="width: 160px">
              <a-select-option v-for="item in infoSourceDict" :key="item.value" :value="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-range-picker
              v-model="form.infoGetTimeRange"
              :placeholder="['信息获取开始', '信息获取结束']"
              value-format="YYYY-MM-DD"
              style="width: 240px"
            />
          </a-form-model-item>
          <a-form-model-item>
            <a-range-picker
              v-model="form.createTimeRange"
              :placeholder="['创建开始', '创建结束']"
              value-format="YYYY-MM-DD"
              style="width: 220px"
            />
          </a-form-model-item>
          <a-form-model-item>
            <a-range-picker
              v-model="form.estimateOpenBidTimeRange"
              :placeholder="['预计开标开始', '预计开标结束']"
              value-format="YYYY-MM-DD"
              style="width: 240px"
            />
          </a-form-model-item>
          <a-form-model-item>
            <div style="display: inline-flex; align-items: center;">
              <span style="color: #666; margin-right: 6px; white-space: nowrap; font-size: 13px">预计合同额</span>
              <a-input-number
                v-model="form.estimateContractAmountMin"
                :min="0"
                :precision="2"
                placeholder="最小值"
                style="width: 100px"
              />
              <span style="margin: 0 6px; color: #999">-</span>
              <a-input-number
                v-model="form.estimateContractAmountMax"
                :min="0"
                :precision="2"
                placeholder="最大值"
                style="width: 100px"
              />
            </div>
          </a-form-model-item>
          <a-form-model-item>
            <a-space>
              <a-button type="primary" icon="search" @click="query">搜索</a-button>
              <a-button icon="redo" @click="reset">清空</a-button>
              <a @click="searchExpanded = false" style="font-size: 13px">
                收起 <a-icon type="up" style="font-size: 12px" />
              </a>
            </a-space>
          </a-form-model-item>
        </template>
      </a-form-model>

      <Padding />

      <!-- 工具栏 -->
      <div class="toolbar">
        <a-button type="primary" @click="handleAdd">新增项目备案</a-button>
        <a-button type="primary" @click="handleResubmit" :disabled="!canResubmit">重启备案</a-button>
<!--        <a-button @click="handleAssign" :disabled="selectedRowKeys.length === 0">分配</a-button>-->
        <a-button @click="handleExport" :loading="exportLoading">导出</a-button>
<!--        <a-button type="primary" @click="handleBidApply" :disabled="!canBidApply">投标申请</a-button>-->
      </div>

      <!-- 表格 -->
      <a-table
        bordered
        :columns="columns"
        :data-source="dataSource"
        :pagination="pagination"
        :loading="loading"
        :scroll="{ x: 2800 }"
        :row-selection="{ type: 'radio', selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
        row-key="id"
        class="mt-16"
      >
        <span slot="biddingType" slot-scope="text">
           {{ getDictName('scrm.scrm_bidding_type', text.toString()) }}
        </span>

        <template slot="approveStatus" slot-scope="text">
          <a-tag :color="getApproveStatusColor(text)">{{ getDictName('cosys.approveStatus', text) }}</a-tag>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleFollow(record)">跟进</a>
        </span>
      </a-table>
    </a-card>

    <!-- 新增/重启备案弹窗 -->
    <a-modal
      :title="isResubmit ? '重启备案' : '新增项目备案'"
      :visible="addVisible"
      :width="1200"
      :footer="null"
      @cancel="handleAddCancel"
    >
      <Add v-if="addVisible" mode="dialog" :dialog-edit-id="resubmitId" :resubmit="isResubmit" @success="handleAddSuccess" @cancel="handleAddCancel" />
    </a-modal>

    <!-- 关闭弹窗 -->
    <a-modal
      title="关闭项目备案"
      :visible="closeVisible"
      :confirm-loading="closeLoading"
      @ok="handleCloseOk"
      @cancel="closeVisible = false"
    >
      <a-form-item label="关闭原因">
        <a-textarea
          v-model="closeReason"
          :rows="4"
          placeholder="请输入关闭原因"
        />
      </a-form-item>
    </a-modal>

    <!-- 跟进弹窗 -->
    <a-modal
      title="跟进记录"
      :visible="followVisible"
      :footer="null"
      :width="960"
      @cancel="followVisible = false"
      :destroy-on-close="true"
      centered
    >
      <CrmFollow
        v-if="followVisible"
        :target-id="followTargetId"
        target-type="projectFiling"
        @refresh="loadData"
      />
    </a-modal>

    <!-- 投标申请弹窗 -->
    <a-modal
      :title="bidApplyViewOnly ? '查看投标申请' : (bidApplyData ? '编辑投标申请' : '项目投标申请')"
      :visible="bidApplyVisible"
      :width="1200"
      :confirm-loading="bidApplyLoading"
      :ok-text="bidApplyViewOnly ? null : '确认'"
      cancel-text="关闭"
      :footer="bidApplyViewOnly ? null : undefined"
      @ok="handleBidApplyOk"
      @cancel="handleBidApplyCancel"
      :destroy-on-close="true"
      centered
    >
      <BidApplyForm
        v-if="bidApplyVisible"
        ref="bidApplyFormRef"
        :detail="bidApplyRecord"
        :bid-apply-data="bidApplyData"
        :project-name="bidApplyRecord.projectName"
        :view-only="bidApplyViewOnly"
      />
    </a-modal>

    <!-- 分配弹窗 -->
    <a-modal
      title="分配负责人"
      :visible="assignVisible"
      :confirm-loading="assignLoading"
      @ok="handleAssignOk"
      @cancel="assignVisible = false"
    >
      <a-form-model
        ref="assignForm"
        :model="assignForm"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="已选备案数">
          <span>{{ selectedRowKeys.length }} 条</span>
        </a-form-model-item>
        <a-form-model-item
          label="新负责人"
          prop="newChargeUserId"
          :rules="[{ required: true, message: '请选择新负责人' }]"
        >
          <EmployeeSelector
            @change="(arr) => { assignForm.newChargeUserId = arr.length ? arr[0].userId : undefined; assignForm.newChargeUserName = arr.length ? arr[0].name : '' }"
            :value="assignForm.newChargeUserId ? [{ userId: assignForm.newChargeUserId, name: assignForm.newChargeUserName }] : []"
          >
            <a-button block style="text-align: left">
              <span v-if="assignForm.newChargeUserName">{{ assignForm.newChargeUserName }}</span>
              <span v-else style="color: #bfbfbf">请选择</span>
            </a-button>
          </EmployeeSelector>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { fetchDetailProduct } from "@/api/setting/organization";
import { fetchTopList as fetchAreaTopList } from "@/api/setting/area";
import {
  getProjectFilingList,
  deleteProjectFiling,
  getProjectFilingDetail,
  closeProjectFiling,
  convertProjectFiling,
  assignProjectFiling
} from "@/api/market/projectFiling";
import city from "@/mixins/city";
import organization from "@/mixins/organization";
import watermark from "@/mixins/watermark";
import request from "@/api/request";
import download from "@/api/download";
import { getBidApplyByProject, addBidApply, updateBidApply } from "@/api/market/bidApply";
import { saveAs } from "file-saver";
import { getApproveStatusColor } from "@/utils/columns";
import Add from "./add.vue";
import EmployeeSelector from "@/components/employee-selector/index.vue";
import BidApplyForm from "@/views/market/project/BidApplyForm.vue";
import CrmFollow from "@/components/crm-follow/index.vue";

// API 方法已移至 @/api/market/projectFiling

export default {
  mixins: [city, organization, watermark],

  components: {
    Add,
    EmployeeSelector,
    BidApplyForm,
    CrmFollow
  },

  data() {
    return {
      // 搜索表单
      form: {},
      productionOrgList: [],
      staffList: [],
      areaList: [],
      registerUserName: "",
      chargeUserName: "",
      searchExpanded: false,

      // 新增弹窗
      addVisible: false,

      // 列表数据
      dataSource: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`
      },
      // 关闭弹窗
      closeVisible: false,
      closeLoading: false,
      closeReason: "",
      closeId: null,
      // 选中行
      selectedRowKeys: [],
      // 分配弹窗
      assignVisible: false,
      assignLoading: false,
      assignForm: {
        newChargeUserId: undefined,
        newChargeUserName: ""
      },
      // 导出
      exportLoading: false,
      // 重启备案
      isResubmit: false,
      resubmitId: null,
      // 投标申请
      bidApplyVisible: false,
      bidApplyLoading: false,
      bidApplyData: null,
      bidApplyRecord: {},
      bidApplyViewOnly: false,
      // 跟进
      followVisible: false,
      followTargetId: null
    };
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("auth", ["department"]),
    ...mapGetters("setting", ["findDataDict"]),

    specialtyDict()  { return this.findDataDict("scrm.scrm_project_specialty"); },
    categoryDict()   { return this.findDataDict("scrm.scrm_project_category"); },
    infoSourceDict() { return this.findDataDict("scrm.scrm_info_source"); },
    biddingTypeDict(){ return this.findDataDict("scrm.scrm_bidding_type"); },
    classifyDict()   { return this.findDataDict("scrm.scrm_project_classify"); },
    approveStatusDict() {
      const names = ['已创建', '已结束', '已终止', '已驳回', '审核中'];
      return this.findDataDict("cosys.approveStatus")?.filter(item => names.includes(item.name)) || [];
      },

    columns() {
      const dictLabel = (dict, val) => {
        if (!val) return '—';
        return val.split(',').map(v => {
          const item = dict.find(d => d.value === v);
          return item ? item.name : v;
        }).join('、');
      };
      return [
        { title: "备案编号", dataIndex: "filingNum", width: 100, fixed: "left",
          customRender: (text, record) => (
            <a onClick={() => this.handleView(record)}>{text}</a>
          )
        },
        {
          title: "项目状态", dataIndex: "status", width: 100, fixed: "left",
          scopedSlots: { customRender: "approveStatus" }
        },
        { title: "项目名称",      dataIndex: "projectName",             width: 200 },
        { title: "业主单位",      dataIndex: "customerName",            width: 180 },
        { title: "联系人",        dataIndex: "contactName",             width: 100 },
        { title: "登记部门",      dataIndex: "registerDeptName",        width: 150 },
        { title: "登记人",        dataIndex: "registerUserName",        width: 100 },
        { title: "主办生产部门",   dataIndex: "productionDeptName",      width: 150 },
        { title: "负责人",        dataIndex: "chargeUserName",          width: 120 },
        { title: "所属区域",      dataIndex: "areaName",                width: 100 },
        {
          title: "项目所在地", dataIndex: "provinceCode", width: 200,
          customRender: (text, record) =>
            record.projectAddressType === 2
              ? '国外'
              : [record.provinceCode, record.cityCode, record.regionCode].filter(Boolean).join('') || '—'
        },
        {
          title: "项目属性", dataIndex: "projectProperty", width: 220, ellipsis: true
        },
        { title: "项目分类",      dataIndex: "projectClassify",         width: 100 },
        { title: "预计合同额(万元)", dataIndex: "estimateContractAmount", width: 140, align: "right" },
        { title: "总投资金额(万元)", dataIndex: "totalInvestmentAmount",  width: 140, align: "right" },
        {
          title: "预计开标时间", dataIndex: "estimateOpenBidTime", width: 120,
          customRender: text => text ? text.slice(0, 10) : '—'
        },
        {
          title: "招投标方式", dataIndex: "biddingType", width: 110,
          scopedSlots: { customRender: "biddingType" }
        },
        {
          title: "信息来源", dataIndex: "infoSource", width: 120,
          customRender: text => dictLabel(this.infoSourceDict, text)
        },
        { title: "来源单位",      dataIndex: "sourceCustomerName",      width: 150 },
        { title: "来源联系人",    dataIndex: "sourceContactName",       width: 100 },
        {
          title: "信息获取时间", dataIndex: "infoGetTime", width: 120,
          customRender: text => text ? text.toString().slice(0, 10) : ''
        },
        {
          title: "停留时长(天)",
          dataIndex: "stayDuration",
          width: 120,
          align: "center",
          customRender: (text, record) => {
            if (!record.createTime) return '—';
            const createTime = new Date(record.createTime);
            const currentTime = new Date();
            const diffTime = currentTime - createTime;
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
            return diffDays;
          }
        },
        {
          title: "最新跟进时间",
          dataIndex: "followTime",
          width: 160,
          customRender: text => text ? text.toString().replace('T', ' ').slice(0, 19) : ''
        },
        { title: "最新跟进内容", dataIndex: "followContent", width: 200, ellipsis: true },
        {
          title: "创建时间", dataIndex: "createTime", width: 160,
          customRender: text => text ? text.toString().replace('T', ' ').slice(0, 19) : ''
        },
        { title: "操作", dataIndex: "action", width: 60, fixed: "right",
          scopedSlots: { customRender: "action" }
        }
      ];
    },

    currentUser() {
      if (this.user && this.user.uuid) return this.user;
      try { return JSON.parse(window.localStorage.getItem("user") || "{}"); }
      catch (e) { return {}; }
    },

    currentDept() {
      const u = this.currentUser;
      if (u && u.employeeVo) return u.employeeVo;
      return this.department || {};
    },

    canBidApply() {
      if (this.selectedRowKeys.length !== 1) return false;
      const record = this.dataSource.find(r => r.id === this.selectedRowKeys[0]);
      return record && record.status === 'End';
    },

    canResubmit() {
      if (this.selectedRowKeys.length !== 1) return false;
      const record = this.dataSource.find(r => r.id === this.selectedRowKeys[0]);
      return record && (record.status === 'Create' || record.status === 'Cancel');
    }
  },

  mounted() {
    this.loadData();
    // 加载区域列表
    fetchAreaTopList().then((res) => {
      this.areaList = Array.isArray(res) ? res : (res.list || []);
    }).catch(() => {});
    // 加载部门列表
    fetchDetailProduct().then((res) => {
      this.productionOrgList = Array.isArray(res) ? res : (res.list || []);
    });
    // 加载员工列表
    request({
      url: "/user-service/talentMap/list",
      method: "post",
      data: { pageNum: 1, pageSize: 1000 }
    }).then((res) => {
      this.staffList = res.list || [];
    }).catch(() => {});
  },

  methods: {
    getDictName(dictKey, value) {
      if (!value) return value
      const list = this.findDataDict(dictKey)
      if (!list) return value
      const item = list.find(i => i.value === value)
      return item ? item.name : value
    },

    getApproveStatusColor,
    // 构建查询参数，处理范围日期和金额
    buildParams() {
      const f = this.form;

      // 将合并的 projectProperty 拆分回 projectSpecialty 和 projectCategory
      const specialtyVals = [];
      const categoryVals = [];
      if (Array.isArray(f.projectProperty)) {
        f.projectProperty.forEach(v => {
          if (v.startsWith('s_')) specialtyVals.push(v.slice(2));
          else if (v.startsWith('c_')) categoryVals.push(v.slice(2));
        });
      }

      const params = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        projectName: f.projectName,
        filingNum: f.filingNum,
        ownerCompanyName: f.ownerCompanyName,
        contactName: f.contactName,
        status: f.status,
        areaId: f.areaId,
        projectSpecialty: specialtyVals.length ? specialtyVals.join(',') : undefined,
        projectCategory: categoryVals.length ? categoryVals.join(',') : undefined,
        projectClassify: f.projectClassify,
        biddingType: f.biddingType,
        registerDeptId: f.registerDeptId,
        registerUserId: f.registerUserId,
        productionDeptId: f.productionDeptId,
        chargeUserId: f.chargeUserId,
        infoSourceType: f.infoSourceType,
        provinceCode: f.provinceCode,
        cityCode: f.cityCode,
        regionCode: f.regionCode,
      };
      if (f.infoGetTimeRange && f.infoGetTimeRange.length === 2) {
        params.infoGetTimeStart = f.infoGetTimeRange[0];
        params.infoGetTimeEnd = f.infoGetTimeRange[1];
      }
      if (f.createTimeRange && f.createTimeRange.length === 2) {
        params.createTimeStart = f.createTimeRange[0];
        params.createTimeEnd = f.createTimeRange[1];
      }
      if (f.estimateOpenBidTimeRange && f.estimateOpenBidTimeRange.length === 2) {
        params.estimateOpenBidTimeStart = f.estimateOpenBidTimeRange[0];
        params.estimateOpenBidTimeEnd = f.estimateOpenBidTimeRange[1];
      }
      if (f.estimateContractAmountMin != null) {
        params.estimateContractAmountMin = f.estimateContractAmountMin;
      }
      if (f.estimateContractAmountMax != null) {
        params.estimateContractAmountMax = f.estimateContractAmountMax;
      }
      return params;
    },

    // 加载列表数据
    loadData() {
      this.loading = true;
      getProjectFilingList(this.buildParams())
        .then((res) => {
          this.dataSource = res.list || [];
          this.pagination.total = res.totalSize || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 搜索
    query() {
      this.pagination.current = 1;
      this.loadData();
    },

    // 清空
    reset() {
      this.form = {};
      this.registerUserName = "";
      this.chargeUserName = "";
      this.pagination.current = 1;
      this.loadData();
    },

    // 表格变化
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.loadData();
    },

    // 项目所在地变化
    locationChange(value) {
      if (value && value.length >= 3) {
        this.form.provinceCode = value[0];
        this.form.cityCode = value[1];
        this.form.regionCode = value[2];
      } else {
        this.form.provinceCode = null;
        this.form.cityCode = null;
        this.form.regionCode = null;
      }
    },

    // 新增
    handleAdd() {
      this.addVisible = true;
    },

    // 新增成功
    handleAddSuccess() {
      this.addVisible = false;
      this.isResubmit = false;
      this.resubmitId = null;
      this.loadData();
    },

    // 取消新增
    handleAddCancel() {
      this.addVisible = false;
      this.isResubmit = false;
      this.resubmitId = null;
    },

    // 查看
    handleView(record) {
      this.$router.push({
        path: "/market/projectFiling/detail",
        query: { id: record.id }
      });
    },

    // 跟进
    handleFollow(record) {
      this.followTargetId = record.id;
      this.followVisible = true;
    },

    // 删除
    handleDelete(record) {
      deleteProjectFiling(record.id).then(() => {
        this.$message.success("删除成功");
        this.loadData();
      });
    },

    // 关闭
    handleClose(record) {
      this.closeId = record.id;
      this.closeReason = "";
      this.closeVisible = true;
    },

    // 确认关闭
    handleCloseOk() {
      if (!this.closeReason) {
        this.$message.error("请输入关闭原因");
        return;
      }
      this.closeLoading = true;
      closeProjectFiling(this.closeId, this.closeReason)
        .then(() => {
          this.$message.success("关闭成功");
          this.closeVisible = false;
          this.loadData();
        })
        .finally(() => {
          this.closeLoading = false;
        });
    },

    // 选择行变化
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },

    // 转为正式项目
    handleConvert(record) {
      this.$confirm({
        title: "确认",
        content: "确定将此备案转换为正式项目吗？",
        onOk: () => {
          return convertProjectFiling(record.id).then(() => {
            this.$message.success("转换成功");
            this.loadData();
          });
        }
      });
    },

    // 分配负责人
    handleAssign() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning("请至少选择一条记录");
        return;
      }
      this.assignForm = { newChargeUserId: undefined, newChargeUserName: "" };
      this.assignVisible = true;
    },

    // 确认分配
    handleAssignOk() {
      this.$refs.assignForm.validate(valid => {
        if (!valid) return;
        this.assignLoading = true;
        assignProjectFiling({
          ids: this.selectedRowKeys,
          newChargeUserId: this.assignForm.newChargeUserId,
          newChargeUserName: this.assignForm.newChargeUserName
        }).then(() => {
          this.$message.success("分配成功");
          this.assignVisible = false;
          this.selectedRowKeys = [];
          this.loadData();
        }).finally(() => {
          this.assignLoading = false;
        });
      });
    },

    // 导出
    handleExport() {
      this.exportLoading = true;
      const params = this.buildParams();
      // 移除分页参数，导出全量
      delete params.pageNum;
      delete params.pageSize;
      // 过滤掉值为 undefined / null / '' 的字段，避免拼到 URL 上变成字符串 "undefined"
      Object.keys(params).forEach(key => {
        if (params[key] === undefined || params[key] === null || params[key] === '') {
          delete params[key];
        }
      });
      download({
        url: "/market-service/scrm/project/filing/export",
        method: "get",
        data: params
      }).then(blob => {
        saveAs(blob, "项目备案列表.xlsx");
      }).finally(() => {
        this.exportLoading = false;
      });
    },

    // 投标申请
    handleBidApply() {
      if (this.selectedRowKeys.length !== 1) {
        this.$message.warning("请选择一条记录");
        return;
      }
      const record = this.dataSource.find(r => r.id === this.selectedRowKeys[0]);
      this.bidApplyRecord = record || {};
      this.bidApplyViewOnly = false;
      getBidApplyByProject(record.id)
        .then(res => {
          if (res && res.id) {
            // 已存在投标申请，只读查看
            this.bidApplyData = res;
            this.bidApplyViewOnly = true;
          } else {
            this.bidApplyData = null;
            this.bidApplyViewOnly = false;
          }
        })
        .catch(() => {
          this.bidApplyData = null;
          this.bidApplyViewOnly = false;
        })
        .finally(() => {
          this.bidApplyVisible = true;
        });
    },

    handleBidApplyOk() {
      this.$refs.bidApplyFormRef.validate()
        .then(data => {
          this.bidApplyLoading = true;
          const isEdit = this.bidApplyData && this.bidApplyData.id;
          const apiCall = isEdit
            ? updateBidApply({ id: this.bidApplyData.id, projectFilingId: this.bidApplyRecord.id, ...data })
            : addBidApply({ projectFilingId: this.bidApplyRecord.id, ...data });
          return apiCall;
        })
        .then(() => {
          this.$message.success(this.bidApplyData ? "更新成功" : "提交成功");
          this.bidApplyVisible = false;
          this.bidApplyData = null;
          this.bidApplyRecord = {};
        })
        .catch(() => {})
        .finally(() => {
          this.bidApplyLoading = false;
        });
    },

    handleBidApplyCancel() {
      this.bidApplyVisible = false;
      this.bidApplyData = null;
      this.bidApplyRecord = {};
      this.bidApplyViewOnly = false;
      this.$refs.bidApplyFormRef && this.$refs.bidApplyFormRef.reset();
    },

    handleResubmit() {
      if (this.selectedRowKeys.length !== 1) {
        this.$message.warning("请选择一条记录");
        return;
      }
      const record = this.dataSource.find(r => r.id === this.selectedRowKeys[0]);
      if (!record || (record.status !== 'Create' && record.status !== 'Cancel')) {
        this.$message.warning("只有已创建或已终止状态的备案可以重启");
        return;
      }
      this.isResubmit = true;
      this.resubmitId = record.id;
      this.addVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  padding: 16px;
}

.toolbar {
  margin-bottom: 12px;

  button {
    margin-right: 8px;
  }
}

.mt-16 {
  margin-top: 16px;
}

.text-danger {
  color: #f5222d;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tip-text {
  color: #999;
  margin-top: 4px;
  line-height: 1.5;
}

.property-group {
  .group-label {
    font-size: 13px;
    color: #333;
    font-weight: 500;
    margin-bottom: 8px;
  }
}
</style>
